import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavSystemeComponent } from './nav-systeme/nav-systeme.component';

@NgModule({
	declarations: [NavSystemeComponent],
	imports: [RouterModule, CommonModule],
	exports: [NavSystemeComponent]
})
export class SystemeModule {}
